import AppDialog from "./GlobalDialog";

const Dialog = {
  install(Vue) {
    this.EventBus = new Vue();

    Vue.component("app-global-dialog", AppDialog);

    Vue.prototype.$dialog = {
      show(params) {
        return new Promise((resolve, reject) => {
          params.resolve = resolve;
          params.reject = reject;
          Dialog.EventBus.$emit("show", params);
        });
      }
    };
  }
};

export default Dialog;
